export const LISTING_PRODUCT_UPLOAD_PLATFORM_NAMES = [
  'THERANGEPLUS',
  'DSCO',
  'AMAZONVENDOR',
  'AMAZONSELLER',
  'NAMSHI',
  'WAYFAIR',
  'OVERSTOCK',
  'ABEBOOKS',
  'NOON',
  'NOONV2',
  'GROUPON',
  'WALMART',
  'WALMARTWFS',
  'WALMARTMCS',
  'SHIPHERO',
  'CDON',
  'FARFETCH',
  'MANOMANO',
  'COMMERCEHUB',
  'MYNTRA',
  'RADIAL',
  'RADIAL_DROPSHIP',
] as const

export const LISTING_WAREHOUSE_UPLOAD_PLATFORM_NAMES = [
  'NOON',
  'NOONV2',
  'NAMSHI',
  'WAYFAIR',
  'RADIAL',
  'RADIAL_DROPSHIP',
] as const

const LISTING_PRODUCT_UPLOAD_PLATFORM_NAMES_SET = new Set<string>(
  LISTING_PRODUCT_UPLOAD_PLATFORM_NAMES
)

const LISTING_WAREHOUSE_UPLOAD_PLATFORM_NAMES_SET = new Set<string>(
  LISTING_WAREHOUSE_UPLOAD_PLATFORM_NAMES
)

export const isListingProductUploadPlatform = (platformName?: string | null): boolean =>
  LISTING_PRODUCT_UPLOAD_PLATFORM_NAMES_SET.has(`${platformName ?? ''}`.trim().toUpperCase())

export const isListingWarehouseUploadPlatform = (platformName?: string | null): boolean =>
  LISTING_WAREHOUSE_UPLOAD_PLATFORM_NAMES_SET.has(`${platformName ?? ''}`.trim().toUpperCase())
